export default __webpack_public_path__ + "static/media/backend.1bb12b10.png";